import React from "react";
import {
  breakpointClasses,
  cn,
  resolveElement,
  splitBreakpointProps,
} from "@/lib/utils";
import type { SkeletonElement, SkeletonProps } from "./types";

function Skeleton<E extends React.ElementType = SkeletonElement>({
  as: Tag,
  asChild = false,
  className,
  ...props
}: SkeletonProps<E>) {
  const Component = resolveElement(asChild, Tag, "div");
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  if (process.env.NODE_ENV !== "production" && Tag && asChild) {
    console.warn(
      `[Skeleton] 'asChild' renders the child element; 'as' is ignored.`,
    );
  }

  return (
    <Component
      className={cn(
        "w-full h-full animate-pulse rounded-sm bg-muted",
        className,
        classes,
      )}
      {...native}
    />
  );
}

export default Skeleton;
